/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* codigos necessarios pra pagina de produto funcionar */

function calculadora(){
	  var  valor = $('.precoto').text().replace('R$ ', '').replace(',', '.')
      var qtd = $('.qty').val()
      var resultado = (qtd * valor).toFixed(2)
      var resultado = resultado.toString().replace('.', ',')
      $('.precoto').text('R$ ' + resultado)  
      var preco = parseFloat(valor);
      var calculo = ((preco + 0) * 1.1979) / 12;
      var calculo = calculo.toFixed(2).replace('.', ',');
      var calculo = ('R$ ' + calculo);
 	  $('.parcelamento span b').html(calculo);
      var jpix = $('.precoto').text().replace('R$ ', '').replace(',', '.') * 0.02;
      $('.vpix').text('R$ ' + ($('.precoto').text().replace('R$ ', '').replace(',', '.') - jpix).toFixed(2).replace('.', ','))
}

function parcela(){
	var vt = (($('.parcelamento').attr('parcelamento') * $('.qty').val()) / 12).toFixed(2).toString().replace('.', ',')
    $('.parcelamento span b').text('R$ ' + vt)
}


function calculadora2(){
	  var  valor = $('.precoto').attr('preco').replace(',', '.')
      var qtd = $('.qty').val()
      var resultado = (qtd * valor).toFixed(2)      
  	  var dinheiro = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(resultado)
      $('.precoto').text(dinheiro) 
      setTimeout(function () { 
      var jpix = ($('.precoto').attr('preco').replace(',', '.') * qtd) * 0.02
      var teste = ($('.precoto').attr('preco').replace(',', '.') * qtd)  - jpix
      var dinheiro2 = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(teste)
       $('.vpix').text(dinheiro2)
       }, 150);
}


$(document).ready(function() {
  var $buttonPlus = $('.qtyplus');
  var $buttonMin = $('.qtyminus');
  var $quantity = $('.qty');
  
  /*For plus and minus buttons*/
  $buttonPlus.click(function() {
    $quantity.val(parseInt($quantity.val()) + 1).trigger('input');
    
    calculadora2()    
    parcela()
  });
  
  $buttonMin.click(function() {
    $quantity.val(Math.max(parseInt($quantity.val()) - 1, 1)).trigger('input');
    setTimeout(function () { 
    calculadora2()
    parcela()
      }, 150);
  });
})


if (window.matchMedia("(max-width: 768px)").matches) {
  	window.onscroll = function() {
      var pageOffset = document.documentElement.scrollTop || document.body.scrollTop,
          btn = document.getElementById('scrollToTop');
      if (btn) btn.style.display = pageOffset > 500 ? 'block' : 'none';
	}
} 


/*

function convertDate(inputFormat) {
  function pad(s) { return (s < 10) ? '0' + s : s; }
  var d = new Date(inputFormat);
  return [pad(d.getDate())].join('/');
}

function getMesExtenso(mes){
  return this.arrayMes[mes];
}

var arrayMes = new Array(12);
arrayMes[0] = "janeiro";
arrayMes[1] = "fevereiro";
arrayMes[2] = "março";
arrayMes[3] = "abril";
arrayMes[4] = "maio";
arrayMes[5] = "junho";
arrayMes[6] = "julho";
arrayMes[7] = "agosto";
arrayMes[8] = "setembro";
arrayMes[9] = "outubro";
arrayMes[10] = "novembro";
arrayMes[11] = "dezembro";

var showMes = "";

var date = new Date();
var diax = date.setDate(date.getDate() + 7);
var diay = date.setDate(date.getDate() + 7);
var mes = getMesExtenso(date.getMonth());

function data(data){

  var d = new Date(data);
  return getMesExtenso(d.getMonth());

}

if(data(diax) !== data(diay)){
  showMes = " de " + data(diax);
}


$.getJSON( "https://wtfismyip.com/json", function(localizacao) {
  var localizacao = localizacao['YourFuckingLocation'];
  var regiao = localizacao.replace(", Brazil", "");
  $(".custom-address").html("<font color='green'><b>Frete Grátis</b></font> para <font color='#f78806'><b>" + regiao + " e Região.</b></font>");
  $(".shipping-estimated").html("Estimade entre <strong>" + convertDate(diax) + showMes + " e " + convertDate(diay) + " de " + mes + "</strong>.");

});

*/
window.onload = function(){
$('.shopify-payment-button__button--unbranded').text('Compre Agora!')
}

